// extracted by mini-css-extract-plugin
export default {"handle":"Handle--handle--uh2wk"};